import React from 'react';
import LocationTemplate from './LocationTemplate';

const BuxtonPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Buxton"
      stateName="North Carolina"
      countyName="Dare"
      zipCodes={["27920"]}
      latitude={35.2704}
      longitude={-75.5335}
      population={1273}
      historicalFact="Named after early settler family, known for Cape Hatteras Lighthouse and National Seashore."
      nearbyTowns={[
        "Hatteras, NC",
        "Frisco, NC",
        "Avon, NC",
        "Salvo, NC",
        "Cape Hatteras, NC",
        "Ocracoke, NC",
        "Rodanthe, NC",
        "Waves, NC"
      ]}
    />
  );
};

export default BuxtonPage;